// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import awsmobile from './Config/aws-exports';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Toaster } from './Components/UI/toaster';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { initializeWavEncoder } from './utils/wavEncoderSetup';
import { HelmetProvider } from 'react-helmet-async';

Amplify.configure(awsmobile);

// Initialize WAV encoder for audio recording (must be done once at app startup)
initializeWavEncoder().catch((error) => {
  console.warn('Failed to initialize WAV encoder - audio recording may not work optimally', error);
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <HelmetProvider>
      <GoogleOAuthProvider clientId="173420198331-e50pusog3oil68adhreets71rs92do4p.apps.googleusercontent.com">
        <App />
        <Toaster />
      </GoogleOAuthProvider>
    </HelmetProvider>
);